import { render } from "./Navbaroptions.vue?vue&type=template&id=5b3cd558"
import script from "./Navbaroptions.vue?vue&type=script&lang=js"
export * from "./Navbaroptions.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src618844026/src/meta-page-client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__